// themes/oliveTheme.ts
import {createTheme} from "@mui/material/styles";

export const oliveTheme = createTheme({
    palette: {
        mode: "light",
        background: {
            default: "#697748", // olive earth
            paper: "rgba(255, 255, 255, 0.15)",
        },
        primary: {
            main: "#c4c8ab", // khói pastel
        },
        secondary: {
            main: "#869064", // olive nhạt
        },
        text: {
            primary: "#414335",
            secondary: "#c4c8ab"
        },
    },

    shape: {
        borderRadius: 12,
    },

    typography: {
        fontFamily: '"Orbitron", sans-serif',
        button: {
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "0.9rem",
        },
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#697748",
                    backgroundImage: `linear-gradient(rgba(89, 104, 49, .65),rgb(89 104 49 / 85%)),url('/assets/3.jpeg')`,
                    // backgroundImage: `linear-gradient(rgba(89, 104, 49, .65), rgba(89, 104, 49, .95)),url('/assets/3.jpeg')`,

                    backgroundRepeat: 'no-repeat',
                    // backgroundPosition: 'center',
                    // backgroundSize: '100% auto',
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                    " & .MuiSideBar": {
                        position: "relative",
                        borderRadius: "12px",
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        // backgroundColor: 'rgba(134, 144, 100, 0.65)',
                        padding: "16px",
                        width: "100%",
                        maxWidth: "100%",
                        color: "white",
                        fontSize: {lg: '1.4rem', md: "0.875rem"},
                        margin: "0 auto 20px",
                        " & .titleBox": {
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: " rgba(255, 255, 255, 0.65)",
                            borderRadius: "8px",
                            padding: "6px 16px",
                            width: "100%",
                            marginBottom: {lg: "16px", md: 0},
                            " & .titleText": {
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                color: "#687543",
                                letterSpacing: "1px",
                                fontSize: "1rem",
                            }
                        }
                    },

                    " & .MuiMessage": {
                        padding: 24,
                        textAlign: "center",
                        borderRadius: "12px",
                        // background: "rgba(255, 255, 255, 0.5)",
                        color: "white",
                        fontFamily: '"Orbitron", sans-serif',
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        letterSpacing: "1px",
                    },

                    "& .CenterButton": {
                        minWidth: "100px",
                        height: "160px",
                        borderRadius: "50%", // oval dọc
                        background: "radial-gradient(circle at 50% 50%, #fffbe6, #f6d887)",
                        border: "2px solid #D4AF37",
                        boxShadow: "0 6px 18px rgba(212,175,55,.35)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transition: "all 0.25s ease",
                        padding: 0,
                        "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 12px 24px rgba(212,175,55,.45)",
                            "& .MuiSvgIcon-root": {
                                color: "#FFD700",
                                filter: "drop-shadow(0 0 8px rgba(255,215,0,0.6))",
                            },
                        },
                        "& .MuiSvgIcon-root": {
                            fontSize: "64px",
                            color: "#B68C2B",
                            transition: "all 0.4s ease",
                        },
                    },

                    " .background-transparent": {
                        background: "transparent!important"
                    }

                },
                "*": {
                    boxSizing: "border-box",
                },

            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    "&.muiButtonIcon": {
                        fill: "#D4AF37"
                    },
                }
            }
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    fontWeight: "bold",
                    fontFamily: '"Orbitron", sans-serif',
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    backgroundColor: "rgba(255,255,255,0.6)",
                    color: "#687543",
                    boxShadow: "0 0 6px rgba(122, 94, 59, 0.4)",
                    " &.muiButtonIcon": {
                        fill: "red"
                    },
                    "&:hover": {
                        backgroundColor: "#869064",
                        color: "white",
                        boxShadow: "0 0 12px #7a5e3b",
                    },
                    "&:active": {
                        transform: "scale(0.98)",
                    },
                    "&.active": {
                        backgroundColor: "#687543",
                        // backgroundColor: "#869064",
                        color: "white",
                        boxShadow: "0 0 12px #7a5e3b",
                        " &.muiButtonIcon": {
                            fill: "white"
                        }
                    },
                    "&.centerButtons": {
                        fontSize: {lg: '1.15rem', md: "0.875rem"}
                    }
                },
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(255,255,255,0.2)",
                    borderRadius: 12,
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#c4c8ab",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#c4c8ab",
                        boxShadow: "0 0 6px #c4c8ab",
                    },
                    input: {
                        color: "#414335",
                    },
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    borderRadius: 16,
                    backdropFilter: "blur(6px)",
                    boxShadow: "0 0 6px rgba(122, 94, 59, 0.2)",
                },
            },
        },

        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 16,
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(255, 255, 255, 0.75)",
                    boxShadow: "0 0 16px rgba(122, 94, 59, 0.6)",
                    padding: '16px 24px',
                    color: "#2d2d2d", // chữ đậm màu hơn
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontWeight: 700,
                    fontSize: "1.25rem",
                    color: "#3a2e1f",
                },
            },
        },

        MuiTypography: {
            styleOverrides: {
                root: {
                    color: "#414335",
                    fontWeight: 700,
                    fontSize: "1.125rem"
                },
                h6: ({theme}) => ({
                    color: "white",
                    fontSize: "1rem", // default (md trở xuống)
                    [theme.breakpoints.up("lg")]: {
                        fontSize: "1.4rem",
                    },
                }),
            },
        },

        MuiListItemText: {
            styleOverrides: {
                primary: ({theme}) => ({
                    fontFamily: '"Orbitron", sans-serif',
                    fontSize: "0.875rem",
                    [theme.breakpoints.up("lg")]: {
                        fontSize: "0.95rem",
                    },
                    color: "#414335",
                }),
            },
        },

        MuiAutocomplete: {
            styleOverrides: {
                paper: {
                    backgroundColor: "rgba(255,255,255,0.95)",   // rõ, không blur
                    backdropFilter: "none",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
                    borderRadius: 16,
                },
                listbox: {
                    padding: 16,
                    maxHeight: 300,
                    overflowY: "auto",
                }
            }
        }
    },
});
